window.o_global = window.o_global || {};
window.o_util = window.o_util || {};

/**
 * Helper functions for hash handling within URLs (e.g. https://otto.de/#value=5)
 *
 * @param {Object} core     o_util_core
 *
 * @return {Object} Public methods of o_util.hash.
 */
o_util.fragment = (function(core) {
    "use strict";

    /**
     * Transforms an object into a fragment string.
     * [jQuery] Replaces $.param.fragment([val]);
     *
     * @example
     * o_util.fragment.serialize({
     *      "a": 5,
     *      "b": 10
     * }); // returns "#a=5&b=10"
     *
     * @param {Object} obj      Object to serialize
     * @returns {String}        Serialized object as string.
     */
    function serialize(obj) {
        if (obj && typeof obj === "object") {
            return "#" + core.serialize(obj);
        }
    }

    /**
     * Transforms window.location.hash or a fragment string into an object.
     *
     * [jQuery] Replaces $.deparam.fragment([val]);
     *
     * @example
     * // If window.location.hash is #a=5&b=10
     * o_util.fragment.deserialize(); // returns {"a": 5, "b": 10}
     *
     * // If window.location.hash is #a=5&b=10 and coerce set as false
     * o_util.fragment.deserialize(false); // returns {"a": "5", "b": "10"}
     *
     * // If fragment is used as parameter
     * o_util.fragment.deserialize("#a=5&b=true"); // returns {"a": 5, "b": true}
     *
     * // If coercing is explicit set as false
     * o_util.fragment.deserialize("#a=5&b=true", false); // returns {"a": 5, "b": "true"}
     *
     * @param {String|undefined} fragment   String or native hash
     * @param {Boolean} [coerce=true]       A value to enable type casting (e.g. "true" gets boolean true)
     * @returns {Object}                    The resulting object or an empty object if there was no fragment.
     */
    function deserialize(fragment, coerce) {
        // If deserialize was called with only a boolean parameter, expect it to be the coerce value for window.location.hash
        if(typeof fragment === "boolean" && typeof coerce === "undefined") {
            coerce = fragment;
        } else {
            // Otherwise set it default to true, if not existent
            coerce = typeof coerce === "boolean" ? coerce : true;
        }

        if (typeof fragment === "string") {
            if (fragment.indexOf("#") > -1) {
                return core.deserialize(fragment.split("#")[1], coerce);
            } else {
                return {};
            }
        } else {
            if (!window.location.hash) {
                return {};
            } else {
                return core.deserialize(window.location.hash.substring(1), coerce);
            }
        }
    }

    /**
     * Returns the value of a given key from the fragment of window.location.hash
     * or an optional specified `url`.
     *
     * [jQuery] Replaces $.bbq.getState([val]);
     *
     * @example
     * // If window.location.hash is #a=5&b=true
     * o_util.fragment.get("b") === true
     * o_util.fragment.get("a") === 5
     *
     * @param {String} param The target fragment key
     * @param {String} [url] URL containing a fragment (optional)
     * @returns {String} value   Value of Hash-Key or the whole fragment
     */
    function get(param, url) {
        if (typeof param === "string") {
            var deserialized;

            if (!!url && url.indexOf("#") > -1) {
                deserialized = deserialize("#" + url.split("#")[1]);
            } else {
                deserialized = deserialize(window.location.hash);
            }

            return deserialized.hasOwnProperty(param) ? deserialized[param] : undefined;
        } else if (!param) {
            return window.location.hash === "#" ? "" : window.location.hash;
        }
    }

    /**
     * Removes a given key from the fragment of window.location.hash
     * or optional an `url`.
     *
     * [jQuery] Replaces $.bbq.removeState([val]);
     *
     * @example
     * // If window.location.hash is #a=5&b=true
     * o_util.fragment.remove("a") // Resulting window.location.hash will be #b=true
     *
     * @param   {String} param The target fragment key
     * @param   {String} [url] URL containing a fragment (optional)
     * @returns {*} Returns true or false as done status or if an `url` is given the remaining result
     */
    function remove(param, url) {
        if (typeof param === "string" && !!get(param, url)) {
            var deserialized,
                serialized,
                splitted;

            if (typeof url === "string") {
                if (url.indexOf("#") > 1) {
                    splitted = url.split("#");
                    deserialized = deserialize("#" + splitted[1]);

                    delete deserialized[param];

                    serialized = serialize(deserialized);

                    return splitted[0] + (serialized.length > 1 ? serialized : "");
                } else {
                    return false;
                }
            } else {
                deserialized = deserialize(window.location.hash);

                delete deserialized[param];

                set(serialize(deserialized));

                return true;
            }
        }

        return false;
    }

    /**
     * Overwrites the window.location.hash (fragment) if given value is string.
     *
     * @example
     * o_util.fragment.set("#t=1337");
     *
     * @param {String} fragment  The fragment string
     */
    function set(fragment) {
        if (typeof fragment === "string") {
            window.location.hash = fragment;
        }
    }

    /**
     * Overwrites or merges the value of a specific key in
     * the fragment of window.location.hash or an optional given `url`.
     *
     * [jQuery] Replaces $.bbq.pushState([val]);
     *
     * @example
     * // Fragment as object with given url string
     * o_util.fragment.push({
     *      "hello": "world",
     *      "value": 5
     * }, "https://otto.de/#test=5&hello=a");
     * // Returns "https://otto.de/#test=5&hello=world&value=5"
     *
     *
     * // Fragment as string with existing window.location.hash === #these=exist&can=replace
     * o_util.fragment.push("#hello=world&can=5");
     * // Resulting window.location.hash will be "#these=exist&can=5&hello=world"
     *
     * @param   {String|Object} fragment A serialized OR unserialized fragment
     * @param   {String} [url] URL containing a fragment (optional)
     * @returns {*} The new resulting fragment or undefined, if fragment was not a string.
     */
    function push(fragment, url) {
        // Convert fragment object to string for default handling
        fragment = typeof fragment === "object" ? serialize(fragment) : fragment;

        if (typeof fragment === "string") {
            var target = core.deserialize(fragment.replace("#", ""), false), // The target fragment which should be changed
                source, // The source fragment (`url` or `window.location.hash`)
                merged, // The final result
                splitted; // Splitted `url` param (between `#`)

            if (typeof url === "string") {
                // Replace fragment in `url` string or append
                if (url.indexOf("#") > 1) {
                    splitted = url.split("#");
                    source = core.deserialize(splitted[1], false);
                    // Merge by extending
                    merged = serialize(core.extend(source, target));

                    return splitted[0] + merged;
                } else {
                    return url + fragment;
                }
            } else {
                source = core.deserialize(window.location.hash.substring(1), false);
                merged = serialize(core.extend(source, target));

                set(merged);

                return merged;
            }
        }
    }

    /**
     * Return public API.
     */
    return {
        "serialize": serialize,
        "deserialize": deserialize,
        "get": get,
        "set": set,
        "push": push,
        "remove": remove
    };
}(o_util.core));
